import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import NextButton from 'components/@auth/NextButton';
import Loading from 'components/common/Loading';
import { object, string } from 'prop-types';
import React, { Component } from 'react';
import { I18n } from 'utils/i18n';
import { Link } from 'react-router';
import Heading from '../Heading';
import connector from './connector';

class PrivacyScene extends Component {
  componentDidMount() {
    const { actions, locale } = this.props;
    actions.form.loadContent('privacy', locale);
  }

  handleAccept = () => {
    const { actions } = this.props;
    actions.form.update({ terms: true });
  };

  render() {
    const { content } = this.props;
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 125px)' }}>
        <Heading headline={I18n.t('Privacy.headline')} subheading={I18n.t('Privacy.subheading')} />
        <Typography component="article" sx={{ display: 'flex', flexGrow: 1, overflowY: 'auto' }}>
          {!content.privacy ? (
            <Box sx={{ top: 0, position: 'absolute', left: '-.5em' }}>
              <Loading size={80} />
            </Box>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: content.privacy }} />
          )}
        </Typography>

        <Link to="/auth/login/confirmation">
          <NextButton
            sx={{ m: '10px 0 25px 0' }}
            color="primary"
            fullWidth
            onClick={this.handleAccept}
            variant="contained"
          >
            {I18n.t('Privacy.next')}
          </NextButton>
        </Link>
      </Box>
    );
  }
}

PrivacyScene.propTypes = {
  actions: object.isRequired,
  locale: string.isRequired,
  content: object.isRequired,
};

export default connector(PrivacyScene);
